export const valueType = {
  SHOW_ALL: 'SHOW_ALL',
  SHOW_PARENT: 'SHOW_PARENT',
  SHOW_CHILD: 'SHOW_CHILD'
};
export default { valueType };
